<template>
  <div class="input-wrapper">
    <div class="input-label" :class="{'with-notice': isHaveNotice}">
      <div class="label-text">{{ label }}</div>
      <div v-if="isHaveNotice" class="notice">
        ?
        <div class="notice-msg">
          {{ noticeMessage }}
          <img
            class="notice-arrow"
            src="../../../public/custom/images/notice-arrow.svg"
            alt="Notice arrow"
          />
        </div>
      </div>
    </div>
    <div class="input-block" :class="{ invalid: errors.has(validateRules) }">
      <textarea
        class="input"
        type="text"
        v-model="inputValue"
        :placeholder="placeholder"
        :maxlength="maxLength"
        :name="name"
        @input="$emit('input', inputValue)"
        @paste="$emit('input', inputValue)"
        @maska="$emit('input', $event.target.dataset.maskRawValue)"
        v-validate="validateRules"
        v-maska="maskPattern"
        :disabled="disabled"
      />
    </div>
    <div class="error-block">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "BaseTextareaInput",
  props: {
    label: String,
    isHaveNotice: {
      type: Boolean,
      default: false,
    },
    noticeMessage: String,
    defaultValue: String,
    placeholder: String,
    maxLength: Number,
    name: String,
    validateRules: String,
    maskPattern: String,
    disabled: Boolean,
  },
  data() {
    return {
      inputValue: "" || this.defaultValue,
    };
  },
  computed: {
    errorMessage() {
      return this.errors.first(this.validateRules);
    },
  },
  watch: {
    defaultValue(value) {
      this.inputValue = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
    @include base-input-wrapper;
}

.input-label {
    @include base-input-label;
}

.with-notice {
  display: flex;
}

.mt1 {
    margin-top: 1px;
}

.notice {
    @include base-input-notice;
    margin-left: 5px;

    &:hover {
        .notice-msg {
            display: block;
        }
    }
}

.input-block {
    @include base-input-block;
    height: 86px;
}

.input {
    @include base-input;
    resize: none;
    padding-top: 16px;
}

.invalid {
    border-color: var(--base-input-invalid-border-bgc);
}

.error-block {
    @include base-input-error-block;
}

.notice-msg {
    @include base-notice-msg;
}

.notice-arrow {
    position: absolute;
    bottom: -3px;
    left: 11px;
}
</style>
